import {Link} from "react-router-dom";
import {useEffect, useState} from "react";
import { useLocation } from 'react-router-dom';
import {ROOT_URL} from "../../constants/global";
import {SIDEBAR_ROUTES} from "../../constants/routes";

export default function Breadcrumb({links = []}) {

    let location = useLocation();
    const [routes, setRoutes] = useState(links);

    useEffect(() => {

        if(!links.length) {
            const breadcrumbRoutes = [{key: 1, title: "پنل", url: ROOT_URL+"/dashboard", icon: "icon-home"}]
            let currentUrl = location.pathname.replace(ROOT_URL+"/", "");
            currentUrl = currentUrl.split("/");
            const parentRoute = SIDEBAR_ROUTES.find(sidebarRoute => sidebarRoute.key === currentUrl[0]);
            if(currentUrl.length && parentRoute) {
                let {key, title, url} = parentRoute;
                breadcrumbRoutes.push({key, title, url});
                if(parentRoute.subMenu.length) {
                    const subRoute = parentRoute.subMenu.find(subMenuItem => subMenuItem.key === currentUrl[1]);
                    if(subRoute) {
                        let {key, title} = subRoute;
                        breadcrumbRoutes.push({key, title});
                    }
                }
            }
            setRoutes(breadcrumbRoutes)
        }
// eslint-disable-next-line
    }, [location]);

    return (
        <ul className="flex items-center gap-x-3">
            {
                routes.map((item, index) => (
                    <li key={item.key}>
                        {
                            index + 1 === routes.length ?
                                <p className="text-pol-purple mt-1 text-sm xl:text-base">{item.title}</p> :
                                <Link to={item.url} className="group">
                                    {item.icon ? <i className={`ml-2 group-hover:text-pol-main-purple ${item.icon}`} /> : null}
                                    <span className="group-hover:hover:text-pol-main-purple text-pol-dark font-semibold mt-1 inline-block text-sm xl:text-base">{item.title}</span>
                                    <i className="icon-left-arrow mr-3 text-pol-purple-4 inline-block mb-1" />
                                </Link>
                        }
                    </li>
                ))
            }
        </ul>
    )
}
